import Vue from 'vue'
import selectInput from './common/selectInput'
Vue.component('select-input', selectInput);